import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extrato',
  templateUrl: './extrato.component.html',
})
export class ExtratoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
